<div class="m-3">
    <h2 class="widget-title">{{widget.display.title}}</h2>
</div>
<app-search [widget]="widget" [showFeatured]="false" [enabledFilters]="widget.display.filters" [filters]="widget.filters"></app-search>
